import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.small.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { useDebounce } from 'use-debounce';
import queryparse from 'tricks/string/queryparse';
import { getCoachAiName } from 'utils/i18n';
import createLocation from 'utils/createLocation';
import { getAssetIcon } from 'utils/icons';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import { englifySearchValue, localiseSearchValue } from 'utils/search/translateSearchProps';
import { useFetchMySearchContent } from 'actions/content';
import useFetchList from 'actions/useFetchList';
import useFocusOnMount from 'hooks/useFocusOnMount';
import useBreakpoints from 'hooks/useBreakpoints';
import { Combobox, ComboboxInput, ComboboxMenu, ComboboxMenuItem } from 'components/Combobox';
import Flex, { Box } from 'components/Flex';
import VisuallyHidden from 'components/VisuallyHidden';
import SearchBox, { SearchShapedButton } from 'components/SearchBox';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import { COACH_AI_ROUTE } from '../../pages/coach-ai';
import { NAV_BREAKPOINTS } from './NewNavigation';
var DEBOUNCE_INTERVAL = 300;
function useSearchSuggestions(searchValue) {
  var _useDebounce = useDebounce(searchValue, DEBOUNCE_INTERVAL),
    _useDebounce2 = _slicedToArray(_useDebounce, 1),
    debouncedSearchValue = _useDebounce2[0];
  var debouncedEngSearchValue = englifySearchValue(debouncedSearchValue);
  var hasSearchValue = !!searchValue.trim();
  var searchContent = useFetchMySearchContent({
    searchValue: debouncedEngSearchValue,
    limit: 5,
    enabled: hasSearchValue
  });
  var searchTerms = useFetchList('me/content/searchTerms', {
    query: debouncedEngSearchValue,
    limit: 5,
    enabled: hasSearchValue
  });
  var searchSuggestions = searchTerms.items.map(function (_ref) {
    var value = _ref.value;
    return {
      value: value,
      type: 'search',
      name: value,
      id: value
    };
  });

  // Remove search terms when there is content to show too
  // This is adaptive, i.e. if there is only one search term, we show 4 content items
  // If there are 2 search terms, we show 3 content items, etc.
  // It however there are 5 search terms and 1 content items, we show 4 search terms and the 1 content item
  searchSuggestions = searchSuggestions.slice(0, Math.min(searchSuggestions.length, 5 - Math.min(searchContent.items.length, 3)));

  // Translate search suggestions keys
  searchSuggestions = searchSuggestions.map(function (suggestion) {
    return _objectSpread(_objectSpread({}, suggestion), {}, {
      name: localiseSearchValue(suggestion.value)
    });
  });
  var items = [].concat(_toConsumableArray(searchContent.items.splice(0, 5)), _toConsumableArray(searchSuggestions));
  return {
    items: items,
    isLoading: searchTerms.isLoading || searchContent.isLoading
  };
}
function getPlaylistIdFromLocation(_ref2) {
  var pathname = _ref2.pathname;
  if (pathname.startsWith('/playlist')) {
    var urlSegments = pathname.split('/');
    return Number(urlSegments.at(-1));
  }
}
function getA11yStatusMessage(_ref3) {
  var resultCount = _ref3.resultCount;
  // The first menu item just represents the user's
  // input, not a search suggestion, so we subtract it
  var count = resultCount - 1;
  if (!count) {
    return i18n.t('no_search_suggestions_found');
  }
  if (count > 0) {
    return i18n.t('search_navigation_available_suggestions', {
      count: count
    });
  }
  return '';
}
function NewMainSearch(_ref4) {
  var hasMindsetAgent = _ref4.hasMindsetAgent;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints(),
    isLargerThanMobile = _useBreakpoints[NAV_BREAKPOINTS.small];
  var history = useHistory();
  var location = useLocation();
  var playlistId = getPlaylistIdFromLocation(location);
  var _ref5 = queryparse(location.search),
    term = _ref5.term;
  var _useState = useState(function () {
      return term ? localiseSearchValue(term) : '';
    }),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var trimmedSearchValue = searchValue.trim();

  // Update the search field with the search term query parameter if necessary
  useEffect(function () {
    setSearchValue(function (prevTerm) {
      if (term === prevTerm) {
        return prevTerm;
      } else if (term) {
        return localiseSearchValue(term);
      } else {
        return '';
      }
    });
  }, [term]);
  var _useSearchSuggestions = useSearchSuggestions(trimmedSearchValue),
    menuItems = _useSearchSuggestions.items;
  var searchInputRef = useRef(null);
  function clearSearch() {
    var _searchInputRef$curre;
    setSearchValue('');
    (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus();
  }
  var _useBreakpoints2 = useBreakpoints(),
    isBiggerThanSmallScreen = _useBreakpoints2[NAV_BREAKPOINTS.small];
  useFocusOnMount({
    ref: searchInputRef,
    disabled: isBiggerThanSmallScreen
  });

  // Move focus to search field when opening the `/search` route without a search term
  useEffect(function () {
    if (location.pathname === '/search' && !(term !== null && term !== void 0 && term.trim())) {
      // Using a timout to override the default focus setting
      // that's caused by the `PageTitle` component
      setTimeout(function () {
        var _searchInputRef$curre2;
        (_searchInputRef$curre2 = searchInputRef.current) === null || _searchInputRef$curre2 === void 0 ? void 0 : _searchInputRef$curre2.focus();
      }, 0);
    }
  }, [location.pathname, term]);
  function submitSearchTerm() {
    history.push(createLocation('/search', trimmedSearchValue.length > 0 ? {
      term: englifySearchValue(trimmedSearchValue)
    } : undefined));
  }

  // Submit search when the dropdown menu isn't open
  function handleFormSubmit(e) {
    e.preventDefault();
    submitSearchTerm();
  }
  function invokeTheAIOverlord() {
    history.push(COACH_AI_ROUTE);
  }
  function selectSuggestion(selected) {
    var value = selected.value;
    if (value === trimmedSearchValue || value === undefined) {
      submitSearchTerm();
      return;
    }
    if (value === 'ask-ai') {
      invokeTheAIOverlord();
    }
    var selectedItem = menuItems.find(function (item) {
      return item.id === value;
    });
    if (!selectedItem) {
      return;
    }
    if (selectedItem.type === 'playlist') {
      history.push("/playlists/".concat(selectedItem.id));
    } else if (selectedItem.type === 'topic') {
      history.push("/browse/".concat(selectedItem.id));
    } else if ('value' in selectedItem && selectedItem.value) {
      history.push("/search?term=".concat(selectedItem.value));
    } else {
      history.push(createLocation(location.pathname, {
        asset: selectedItem.id
      }));
    }
  }
  var hasLongAiCoachTitle = t('coach_ai_ask', {
    coachAiName: getCoachAiName()
  }).length > 16;
  return /*#__PURE__*/React.createElement(Flex, {
    role: "search",
    gap: "xxs"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    as: "form",
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/React.createElement(Combobox, {
    inputValue: searchValue
    // Account for the static first menu item
    ,
    resultCount: menuItems.length + 1,
    onSelect: selectSuggestion,
    onInputChange: function onInputChange(e) {
      return setSearchValue(e.target.value);
    },
    getStatusMessage: getA11yStatusMessage,
    canOpenMenu: trimmedSearchValue.length > 0,
    id: "main-search"
  }, /*#__PURE__*/React.createElement(ComboboxInput, {
    required: true,
    as: SearchBox,
    refKey: "wrapperRef"
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    ,
    inputRef: searchInputRef,
    label: t('actions_search'),
    placeholder: t('actions_search'),
    onClear: clearSearch
  }), /*#__PURE__*/React.createElement(ComboboxMenu, {
    "aria-label": t('search_suggestions')
  }, /*#__PURE__*/React.createElement(ComboboxMenuItem, {
    key: "search-input",
    icon: "search",
    value: trimmedSearchValue
  }, t('search_results_view_all', {
    searchInput: trimmedSearchValue
  })), menuItems.map(function (item) {
    var isDisabled = playlistId ? playlistId === item.id : false;
    var assetType = item.type && getContentItemType(item);
    return /*#__PURE__*/React.createElement(ComboboxMenuItem, {
      key: item.id,
      icon: getAssetIcon(item),
      value: item.id,
      text: item.name,
      isDisabled: isDisabled
    }, assetType && /*#__PURE__*/React.createElement(VisuallyHidden, null, t(getContentItemTypeTranslationKey(assetType))), item.name);
  })))), hasMindsetAgent && isLargerThanMobile && /*#__PURE__*/React.createElement(Box, {
    maxWidth: 240
  }, /*#__PURE__*/React.createElement(SearchShapedButton, {
    iconOnly: hasLongAiCoachTitle,
    title: hasLongAiCoachTitle ? t('coach_ai_ask', {
      coachAiName: getCoachAiName()
    }) : undefined,
    variant: "transparent",
    textOverflow: "ellipsis",
    iconRight: /*#__PURE__*/React.createElement(Box, {
      mr: "-xs",
      ml: hasLongAiCoachTitle ? '-xs' : 'xxs'
    }, /*#__PURE__*/React.createElement(CoachAiAvatar, null)),
    onClick: invokeTheAIOverlord
  }, t('coach_ai_ask', {
    coachAiName: getCoachAiName()
  }))));
}
export default NewMainSearch;